<template>
	<div id="service7">
		<Menu areWeinServices="true" selectedRoute="talks"/>
		<div class="colorAzul">
			<section class="secImage1" :style="{ backgroundImage: 'url(' + firstImage + ')' }">
				<div class="fondotransparenteServicio">
					<h1 class="titleServicios">{{title}}</h1>
				</div>
			</section>
			<section class="secTexto">
				<div class="textoContenidoInterno">
					<div class="html">
						<!--
						<h1 class="tituloContenidoInterno">
							<span>{{subtitle}}</span>
						</h1>
						-->
						<h2 class="subtituloContenidoInterno">Preparation and Prevention are Key to Security. Prepare and inform your colleagues, employees or family members who are new to the country.</h2>
						<p class="parrafoContenidoInterno">The security situation in Mexico is quite challenging. Crime statistics are increasing at an alarming rate, and can potentially expose high-value targets to robberies, kidnapping, or extorsion.
						<br><br>
							Preparation and Prevention account for 90% of security outcomes. We can help prepare your organization by providing Security Training and Talks on Personal Security in order to foster prevention at work, at home, or on the road.
						<br><br>
						Topics of our on-site training and talks can include:
						</p>
						<ul class="listaContenidoInterno">
							<li>Security at Home</li>
							<li>Security on the Street</li>
							<li>Handling Extortion or Fraudulent Calls</li>
							<li>What to do when facing an adverse event</li>
							<li>Custom curriculums centered around your specific processes</li>
						</ul>
						<p class="parrafoContenidoInterno">
							<span>Glarus Groups</span> offers these classes through trained personnel at your business or home. This talks can greatly reduce the risk for people new to the country, whether colleagues, employees, or family members. They will be better equipped to avoid being at the wrong place at the wrong time, and will know how to act in potentially perilous circumstances.
						</p>
					</div>

					<cuadro/>
				</div>
			</section>
			<section class="secImage2" :style="{ backgroundImage: 'url(' + secondImage + ')' }">
				<div class="fondoAzulServiciosGrid">
					<h1 class="headGridServices">
						<span>Know how to act</span>
					</h1>

					<div class="gridIcons">
						<div class="precautions" v-for="item in precautions" :key="item.id">
							<span>
								<img :src="item.icon" :alt="item.altIcon">
							</span>
							<h3>{{ item.descripcion }}</h3>
						</div>
					</div>
				</div>
			</section>
		</div>

		<FooterComponent areWeinServicesFooter="true"/>
	</div>
</template>

<script>
// @ is an alias to /src

import Menu from "@/components/Menu2.vue";
import cuadro from "@/components/PopEachService.vue";
import FooterComponent from "@/components/Footer.vue";

//Imagenes del servicio
import imagen1 from "@/assets/img/servicios/7/servicio_7.jpg";
import imagen2 from "@/assets/img/servicios/7/second_.jpg";
import icono01 from "@/assets/img/servicios/7/01.png";
import icono02 from "@/assets/img/servicios/7/02.png";
import icono03 from "@/assets/img/servicios/7/03.png";
import icono04 from "@/assets/img/servicios/7/04.png";
import icono05 from "@/assets/img/servicios/7/05.png";
import icono06 from "@/assets/img/servicios/7/06.png";
import icono07 from "@/assets/img/servicios/7/07.png";
import icono08 from "@/assets/img/servicios/7/08.png";

export default {
	name: "servicio07",
	components: {
		Menu,
		cuadro,
		FooterComponent
	},
	mounted: function() {
		this.$nextTick(function() {
			document.title =
				"Glarus Group - Security Training and Personal Security Talks in Mexico"
		});
	},
	data: function() {
		return {
			title: "Security Training and Personal Security Talks in Mexico",
			// subtitle: "Talks and consultancies on personal security",
			// thirdTitle: "Security is never 100% guaranteed 90% is PREVENTION, 5% is REACTION, 5% is LUCK.",
			firstImage: imagen1,
			secondImage: imagen2,

			precautions: [
				{
					id: "1",
					icon: icono01,
					altIcon: "glarus service 7",
					descripcion: "When walking down the street"
				},
				{
					id: "2",
					icon: icono02,
					altIcon: "glarus service 7",
					descripcion: "When driving the streets"
				},
				{
					id: "3",
					icon: icono03,
					altIcon: "glarus service 7",
					descripcion: "When reaching a traffic light"
				},
				{
					id: "4",
					icon: icono04,
					altIcon: "glarus service 7",
					descripcion: "When in a parking lot"
				},
				{
					id: "5",
					icon: icono05,
					altIcon: "glarus service 7",
					descripcion: "When boarding a cab"
				},
				{
					id: "6",
					icon: icono06,
					altIcon: "glarus service 7",
					descripcion: "When boarding a bus"
				},
				{
					id: "7",
					icon: icono07,
					altIcon: "glarus service 7",
					descripcion: "When inside an ATM area"
				},
				{
					id: "8",
					icon: icono08,
					altIcon: "glarus service 7",
					descripcion: "When visiting a mall"
				}
			]
		};
	}
};
</script>

<style lang="less">
@import url("../../assets/less/soloVariables.less");
@import url("../../assets/less/cssServiciosComponent.less");
</style>
